import { FC, useEffect, useState } from "react"
import { TeamContext } from "../../../types/common";
import { StatsPage } from "../page";
import { StatsType, TournamentIds } from "../../../types/stats";
import { TournamentTableWidget } from "../../../widgets/stats/tournament-table/TournamentTableWidget";
import { Image } from "antd";
import { getSummaryTableByTournament, getTournamentTableImage } from "../../../api/transport/statsTransport";
import { SummaryTableMiniWidget } from "../../../widgets/stats/tournament-table/SummaryTableMiniWidget";
import { Link } from "../../../components";

interface TournamentTablePageProps {
    teamContext?: TeamContext;
    seasonId?: number;
    tournamentId?: number;
    teamId?: number;
}

export const TournamentTablePage: FC<TournamentTablePageProps> = ({
    teamContext,
}) => {
    const [tournamentIds, setTournamentIds] = useState<TournamentIds>();
    const [tournamentTableImage, setTournamentTableImage] = useState<string>('');
    const [summaryTableId, setSummaryTableId] = useState(0);

    useEffect(() => {
        if (!tournamentIds?.tournamentUuid) {
            setTournamentTableImage('');
            return;
        }

        if (teamContext === TeamContext.ACADEMY) {
            getTournamentTableImage(tournamentIds?.tournamentUuid).then(image => {
                setTournamentTableImage(image || '');
            });

            getSummaryTableByTournament(tournamentIds.legacyTournament).then(data => {
                if (!data) {
                    return Promise.reject();
                }

                setSummaryTableId(data.id);
            });
        }

    }, [tournamentIds?.tournamentUuid]);

    return <>
        <StatsPage
            teamContext={teamContext}
            pageType={StatsType.TOURNAMENT_TABLE}
            onTournamentChange={(tournamentUuid, seasonUuid, legacyTournament, legacySeason) => setTournamentIds({
                tournamentUuid, seasonUuid, legacyTournament, legacySeason
            })}
        >
            {tournamentTableImage && (
                <div className="w-full pb-4">
                    <Image src={tournamentTableImage} alt="Итоговая таблица" className="w-full" />
                </div>
            )}
            <div className="flex flex-col sm:flex-row gap-3 p-2">
                {!!summaryTableId && (
                    <Link
                        to={`/tables/?shows=${summaryTableId}`}
                        className="sm:hidden self-end text-center flex items-center justify-center transition-all bg-slate-200 px-3 py-1 sm:px-4 sm:py-2 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm"
                    >
                        Общий зачёт
                    </Link>
                )}
                {tournamentIds?.legacyTournament && tournamentIds?.legacySeason && (
                    <TournamentTableWidget
                        teamName={teamContext}
                        seasonId={tournamentIds.legacySeason}
                        tournamentId={tournamentIds.legacyTournament}
                    />
                )}
                {!!summaryTableId && <div className="hidden sm:block"><SummaryTableMiniWidget
                    summaryTableId={summaryTableId}
                /></div>}
            </div>
        </StatsPage>
    </>
}